import { render, staticRenderFns } from "./MWidget.vue?vue&type=template&id=488058eb&lang=pug&"
import script from "./MWidget.vue?vue&type=script&lang=ts&"
export * from "./MWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports